import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useParams } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.common.white,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    header: {
      fontWeight: 700,
      margin: "24px 0",
    },
    subtitle: {
      width: "40%",
      textAlign: "center",
      marginTop: 24,
      [theme.breakpoints.down("sm")]: {
        width: "90%",
      },
    },
  })
);

const Heading = () => {
  const classes = useStyles();
  let { league } = useParams<any>();

  return (
    <Box className={classes.root}>
      <Typography variant="h4" className={classes.header} align="center">
        Trending {league} DFS Comparisons
      </Typography>
      <Typography
        variant="subtitle1"
        align="center"
        className={classes.subtitle}
      >
        Here are the top compares by our community today! Click to see our
        Head-2-Head analysis.
      </Typography>
    </Box>
  );
};

export default Heading;
